import React, { useState, useEffect } from 'react';
import {
  TempalteCreateCategory,
  TemplateList,
  EditeCategory,
  DeleteCategory
} from "../../../services/AdminService";

import ModalComponent from "../../../components/ModalComponent";
import { Form } from 'react-bootstrap';
import { FaTimes, FaRegFileAlt } from 'react-icons/fa';
// import './Template.css';

const CreateCategory = ({ onCategorySelect, selectedCategory }) => {
  const [categories, setCategories] = useState([]);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [categoryName, setCategoryName] = useState("");
  const [editCategoryData, setEditCategoryData] = useState({ id: "", name: "" });
  const [deleteCategoryId, setDeleteCategoryId] = useState(null);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [apiError, setApiError] = useState("");
  const [hoveredCategory, setHoveredCategory] = useState(null);

  const fetchCategories = async () => {
    try {
      setLoading(true);
      const response = await TemplateList({});
      setCategories(response.data?.data || []);
    } catch (err) {
      setApiError("Failed to fetch categories");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleCreateCategory = async () => {
    if (!categoryName.trim()) {
      setError("Category name is required");
      return;
    }

    setLoading(true);
    setError("");

    try {
      await TempalteCreateCategory({ category_name: categoryName });
      await fetchCategories();
      setShowCreateModal(false);
      setCategoryName("");
    } catch (err) {
      setError("Failed to create category");
    } finally {
      setLoading(false);
    }
  };

  const handleEditCategory = async () => {
    if (!editCategoryData.name.trim()) {
      setError("Category name is required");
      return;
    }

    setLoading(true);
    setError("");

    try {
      await EditeCategory({
        id: editCategoryData.id,
        category_name: editCategoryData.name
      });

      await fetchCategories();
      setShowEditModal(false);
    } catch (err) {
      setError("Failed to update category");
    } finally {
      setLoading(false);
    }
  };

  const confirmDeleteCategory = async () => {
    setLoading(true);
    try {
      await DeleteCategory({ id: deleteCategoryId });
      setShowDeleteModal(false);
      setDeleteCategoryId(null);
      await fetchCategories();
    } catch (err) {
      setError("Error deleting category");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* CATEGORY LIST LAYOUT */}
      <div className="admin-template-category-container">
        <h2 className="admin-template-category-title">
          <FaRegFileAlt style={{ color: '#ffffff', fontSize: 18, marginRight: 8 }} />
          Template Category
        </h2>

        <ul className="admin-template-category-list">
          {categories.map((category) => {
            const isSelected = selectedCategory === category.id;
            const isHovered = hoveredCategory === category.id;

            return (
              <li
                key={category.id}
                className={`admin-template-category-item ${isSelected ? "admin-template-category-selected" : ""}`}
                onClick={() => onCategorySelect(category.id)}
                onMouseEnter={() => setHoveredCategory(category.id)}
                onMouseLeave={() => setHoveredCategory(null)}
              >
                <div className="admin-template-category-content">
                  <span className="admin-template-category-name fs-6">
                    {category.category_name}
                  </span>

                  <div className={`admin-template-category-actions ${(isHovered || isSelected) ? "show" : ""}`}>
                    <button
                      className="admin-template-category-action-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        setEditCategoryData({ id: category.id, name: category.category_name });
                        setShowEditModal(true);
                      }}
                    >
                      <i className="bi bi-pencil-square"></i>
                    </button>

                    <button
                      className="admin-template-category-action-btn delete-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        setDeleteCategoryId(category.id);
                        setShowDeleteModal(true);
                      }}
                    >
                      <i className="bi bi-trash3-fill"></i>
                    </button>
                  </div>
                </div>
              </li>
            );
          })}
        </ul>

        <button
          className="admin-template-category-add-btn"
          onClick={() => setShowCreateModal(true)}
          disabled={loading}
        >
          + Add Category
        </button>

        {/* CREATE CATEGORY MODAL */}
        <ModalComponent
          show={showCreateModal}
          handleClose={() => setShowCreateModal(false)}
          title="Create Category"
          size="md"
          footerButtons={[
            {
              label: "Cancel",
              variant: "outline-secondary",
              onClick: () => setShowCreateModal(false),
              disabled: loading
            },
            {
              label: loading ? "Saving..." : "Save",
              variant: "primary",
              onClick: handleCreateCategory,
              disabled: loading
            }
          ]}
        >
          <div className='p-3'>
            <Form.Group>
              <Form.Label>Category Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter category name"
                value={categoryName}
                onChange={(e) => setCategoryName(e.target.value)}
              />
              {error && <div className="text-danger mt-2">{error}</div>}
            </Form.Group>
          </div>
        </ModalComponent>

        {/* EDIT CATEGORY MODAL */}
        <ModalComponent
          show={showEditModal}
          handleClose={() => setShowEditModal(false)}
          title="Edit Category"
          size="md"
          footerButtons={[
            {
              label: "Cancel",
              variant: "outline-secondary",
              onClick: () => setShowEditModal(false),
              disabled: loading
            },
            {
              label: loading ? "Saving..." : "Save Changes",
              variant: "primary",
              onClick: handleEditCategory,
              disabled: loading
            }
          ]}
        >
          <div className='p-3'>
            <Form.Group>
              <Form.Label>Category Name</Form.Label>
              <Form.Control
                type="text"
                value={editCategoryData.name}
                onChange={(e) =>
                  setEditCategoryData({
                    ...editCategoryData,
                    name: e.target.value,
                  })
                }
              />
              {error && <div className="text-danger mt-2">{error}</div>}
            </Form.Group>
          </div>
        </ModalComponent>

        {/* DELETE CATEGORY MODAL */}
        <ModalComponent
          show={showDeleteModal}
          handleClose={() => setShowDeleteModal(false)}
          title="Delete Category"
          size="md"
          footerButtons={[
            {
              label: "Cancel",
              variant: "outline-secondary",
              onClick: () => setShowDeleteModal(false),
            },
            {
              label: loading ? "Deleting..." : "Delete",
              variant: "danger",
              onClick: confirmDeleteCategory,
              disabled: loading
            }
          ]}
        >
          <div className='p-3'>
            <p>
              Are you sure you want to delete this category?
              <br />
              <strong>This action cannot be undone.</strong>
            </p>
          </div>
        </ModalComponent >
      </div >
    </>
  );
};

export default CreateCategory;
